import React from "react";
import { createPortal } from "react-dom";
import BaseModal from "./BaseModal";
import Button from "../forms/Button";

const ConfirmModal = ({
  isOpen,
  onClose,
  onConfirm,
  title = "Confirm Action",
  message,
  confirmText = "Confirm",
  cancelText = "Cancel",
  variant = "danger",
}) => {
  const modal = (
    <BaseModal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      size="sm"
      elevated
      footer={
        <>
          <Button variant="ghost" onClick={onClose}>
            {cancelText}
          </Button>
          <Button variant={variant} onClick={onConfirm}>
            {confirmText}
          </Button>
        </>
      }
    >
      <p className="text-light-200">{message}</p>
    </BaseModal>
  );

  return createPortal(modal, document.body);
};

export default ConfirmModal;
